import { submitMapRating as submitMapRatingCore } from "@dailywars/core/db";
import { InvalidMapRatingError } from "@dailywars/core/errors";
import { createServerFn } from "@tanstack/react-start";

import { getRequestLogger, logRequestError } from "#/lib/requestLogger.server";
import { mapRatingInputSchema } from "#/lib/serverInputSchemas";
import { invalidMapRatingError, unauthorizedError } from "#/server/errors";
import { resolveRequestGameContext } from "#/server/game/requestGameContext.server";

export const submitMapRating = createServerFn({ method: "POST" })
  .validator(mapRatingInputSchema)
  .handler(async ({ data }): Promise<void> => {
    const { playerId, isAnonymous } = await resolveRequestGameContext();
    if (isAnonymous) {
      throw unauthorizedError("Must be signed in to rate maps");
    }
    getRequestLogger().set({
      ratings: { action: "submit", mapId: data.mapId, rating: data.rating },
    });
    try {
      await submitMapRatingCore({ mapId: data.mapId, playerId, rating: data.rating });
    } catch (error) {
      if (error instanceof InvalidMapRatingError) {
        throw invalidMapRatingError();
      }
      logRequestError({
        log: getRequestLogger(),
        error,
        context: { ratings: { step: "submit", mapId: data.mapId } },
      });
      throw error;
    }
  });
